export default __webpack_public_path__ + "static/media/Todi Mills.9574fc0d.jpg";